/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Dietician_LongInputs */

const en_for_whom_dietician_long = /** @type {(inputs: For_Whom_Dietician_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the calories and macros, write the meals, and your client has the plan in the app. If they share their meal log, you see what they really ate.`)
};

const pl_for_whom_dietician_long = /** @type {(inputs: For_Whom_Dietician_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawiasz kalorie i makro, rozpisujesz posiłki, a podopieczny ma jadłospis w aplikacji. Jeśli udostępni dziennik posiłków, widzisz, co naprawdę zjadł.`)
};

/**
* | output |
* | --- |
* | "Set the calories and macros, write the meals, and your client has the plan in the app. If they share their meal log, you see what they really ate." |
*
* @param {For_Whom_Dietician_LongInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_dietician_long = /** @type {((inputs?: For_Whom_Dietician_LongInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Dietician_LongInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_dietician_long(inputs)
	return en_for_whom_dietician_long(inputs)
});